import React, { useEffect } from "react";
import ArrowRight from "assets/icons/right.svg";
import ArrowLeft from "assets/icons/left.svg";
import {
  ArrowButton,
  CarouselContainer,
  CarouselImage,
  CarouselWrapper,
  CarouselSlide,
  CarouselOverlay,
  CarouselContent,
  CarouselTitle,
  CarouselSubtitle,
  DotsContainer,
  Dot,
} from "./carousel.styles";
import { useHomeState, ACTION_TYPES, useHomeDispatch } from "pages/home/context/home-context";
import { useHomeController } from "pages/home/context/home-controller";
import { useAppState } from "main/context/app-context";

export const CarouselSection = () => {
  const [currentSlide, setCurrentSlide] = React.useState<number>(0);
  const { banners } = useHomeState();
  const { listBanners } = useHomeController();
  const { homeData } = useAppState();
  const homeDispatch = useHomeDispatch();

  const handleSlide = (operation: "next" | "prev") => {
    if (operation === "next") {
      if (currentSlide === banners?.length - 1) {
        setCurrentSlide(0);
      } else {
        setCurrentSlide(currentSlide + 1);
      }
      return;
    }
    if (currentSlide === 0) {
      setCurrentSlide(banners?.length - 1);
    } else {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const handleDotClick = (index: number) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    (async () => {
      // Se os dados já foram carregados no AppState, usa eles
      if (homeData?.banners && !banners) {
        homeDispatch({
          type: ACTION_TYPES.setBanners,
          payload: homeData.banners,
        });
      } else if (!banners && !homeData?.banners) {
        // Só carrega se não existir nem no AppState nem no HomeState
        await listBanners();
      }
    })();
  }, [homeData?.banners, banners]);

  useEffect(() => {
    if (!banners || banners.length === 0) return;

    const interval = setInterval(() => {
      if (currentSlide === banners?.length - 1) {
        setCurrentSlide(0);
      } else {
        setCurrentSlide(currentSlide + 1);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide, banners]);

  if (!banners || banners.length === 0) return null;

  return (
    <CarouselContainer>
      <CarouselWrapper>
        {banners?.map(
          (slide, i) =>
            currentSlide === i && (
              <CarouselSlide
                key={i}
                onClick={slide.url ? () => window.open(slide.url, "_blank") : undefined}
                style={{ cursor: slide.url ? 'pointer' : 'default' }}
              >
                <CarouselImage
                  src={slide.imageUrl}
                  alt={slide.title}
                />
                <CarouselOverlay>
                  <CarouselContent>
                    {slide.title && <CarouselTitle>{slide.title}</CarouselTitle>}
                    {slide.subtitle && <CarouselSubtitle>{slide.subtitle}</CarouselSubtitle>}
                  </CarouselContent>
                </CarouselOverlay>
              </CarouselSlide>
            )
        )}
        <ArrowButton
          className="left"
          onClick={(e) => {
            e.stopPropagation();
            handleSlide("prev");
          }}
        >
          <img src={ArrowLeft} alt="Anterior" />
        </ArrowButton>
        <ArrowButton
          className="right"
          onClick={(e) => {
            e.stopPropagation();
            handleSlide("next");
          }}
        >
          <img src={ArrowRight} alt="Próximo" />
        </ArrowButton>
      </CarouselWrapper>
      <DotsContainer>
        {banners?.map((_item, i) => (
          <Dot
            key={i}
            $active={i === currentSlide}
            onClick={(e) => {
              e.stopPropagation();
              handleDotClick(i);
            }}
            aria-label={`Ir para slide ${i + 1}`}
          />
        ))}
      </DotsContainer>
    </CarouselContainer>
  );
};
